module.exports = __webpack_public_path__ + "static/media/icon-logout.6f0a9460.svg";